import { Component } from '@angular/core';

@Component({
  selector: 'app-companies-icon',
  imports: [],
  templateUrl: './companies-icon.html',
  styleUrl: './companies-icon.scss'
})
export class CompaniesIcon {

}
